"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmoutModule = exports.mountModule = exports.loadModule = exports.getImportedModule = exports.getAllImportedModules = exports.getModules = exports.removeCSS = exports.appendCSS = exports.parseUrlAssets = exports.registerModules = exports.registerModule = exports.clearModules = exports.removeModule = exports.registerRuntimes = exports.moduleLoader = void 0;
var sandbox_1 = require("@ice/sandbox");
var loader_1 = require("./loader");
var runtimeHelper_1 = require("./runtimeHelper");
var globalModules = [];
var importModules = {};
// store css link
var cssStorage = {};
var IS_CSS_REGEX = /\.css(\?((?!\.js$).)+)?$/;
exports.moduleLoader = new loader_1.default();
exports.registerRuntimes = function (runtime) {
    return runtimeHelper_1.parseRuntime(runtime);
};
/**
 * remove module
 * @param name
 */
exports.removeModule = function (name) {
    globalModules = globalModules.filter(function (m) { return m.name !== name; });
    delete importModules[name];
    exports.moduleLoader.removeTask(name);
};
/**
 * clear modules
 */
exports.clearModules = function () {
    // reset module info
    globalModules = [];
    importModules = {};
    exports.moduleLoader.clearTask();
};
/**
 * registerModule
 * @param module
 * @returns
 */
exports.registerModule = function (module) {
    if (!module.url && !module.render) {
        console.error('[icestark module] url and render cannot both be empty. name: %s', module.name);
        return;
    }
    var hasRegistered = globalModules.filter(function (m) { return m.name === module.name; }).length;
    /*
     * If a module registers many times, the former registration will be removed.
     */
    if (hasRegistered) {
        exports.removeModule(module.name);
    }
    globalModules.push(module);
};
exports.registerModules = function (modules) {
    modules.forEach(function (m) { return exports.registerModule(m); });
};
// if css link already loaded, record load count
var filterAppendCSS = function (cssList) {
    return (cssList || []).filter(function (cssLink) {
        if (cssStorage[cssLink]) {
            cssStorage[cssLink] += 1;
            return false;
        }
        else {
            cssStorage[cssLink] = 1;
            return true;
        }
    });
};
var filterRemoveCSS = function (cssList) {
    return (cssList || []).filter(function (cssLink) {
        if (cssStorage[cssLink] > 1) {
            cssStorage[cssLink] -= 1;
            return false;
        }
        else {
            delete cssStorage[cssLink];
            return true;
        }
    });
};
function createSandbox(sandbox, deps) {
    var moduleSandbox = null;
    if (deps || sandbox) {
        if (sandbox) {
            if (typeof sandbox === 'function') {
                // eslint-disable-next-line new-cap
                moduleSandbox = new sandbox();
            }
            else {
                var sandboxProps = typeof sandbox === 'boolean' ? {} : sandbox;
                moduleSandbox = new sandbox_1.default(sandboxProps);
            }
        }
        else {
            moduleSandbox = new sandbox_1.default();
        }
    }
    return moduleSandbox;
}
/**
 * parse url assets
 */
exports.parseUrlAssets = function (assets) {
    var jsList = [];
    var cssList = [];
    (Array.isArray(assets) ? assets : [assets]).forEach(function (url) {
        var isCss = IS_CSS_REGEX.test(url);
        if (isCss) {
            cssList.push(url);
        }
        else {
            jsList.push(url);
        }
    });
    return { jsList: jsList, cssList: cssList };
};
function appendCSS(name, url, root) {
    if (root === void 0) { root = document.getElementsByTagName('head')[0]; }
    return new Promise(function (resolve, reject) {
        if (!root)
            reject(new Error("no root element for css assert: " + url));
        var element = document.createElement('link');
        element.setAttribute('module', name);
        element.rel = 'stylesheet';
        element.href = url;
        element.addEventListener('error', function () {
            console.error("css asset loaded error: " + url);
            return resolve();
        }, false);
        element.addEventListener('load', function () { return resolve(); }, false);
        root.appendChild(element);
    });
}
exports.appendCSS = appendCSS;
/**
 * remove css
 */
function removeCSS(name, node, removeList) {
    var linkList = (node || document).querySelectorAll("link[module=" + name + "]");
    linkList.forEach(function (link) {
        // check link href if it is in remove list
        // compatible with removeList is undefined
        if ((removeList && removeList.includes(link.getAttribute('href'))) || !removeList) {
            link.parentNode.removeChild(link);
        }
    });
}
exports.removeCSS = removeCSS;
/**
 * return globalModules
 */
exports.getModules = function () {
    return globalModules || [];
};
/**
 * get import modules
 */
exports.getAllImportedModules = function () {
    return importModules;
};
/**
 * get import module by name
 */
exports.getImportedModule = function (name) {
    if (typeof name !== 'string') {
        console.error("[icestark-module]: should be string, but get " + typeof name);
        return;
    }
    return importModules[name];
};
/**
 * load module source
 */
exports.loadModule = function (targetModule, sandbox) { return __awaiter(void 0, void 0, void 0, function () {
    var name, url, runtime, moduleSandbox, deps, _a, jsList, cssList_1, moduleInfo_1, _b, moduleInfo, moduleCSS, errMsg, mount, unmount, component, cssList;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                name = targetModule.name, url = targetModule.url, runtime = targetModule.runtime;
                moduleSandbox = null;
                if (!!importModules[name]) return [3 /*break*/, 4];
                deps = null;
                if (!runtime) return [3 /*break*/, 2];
                return [4 /*yield*/, runtimeHelper_1.parseRuntime(runtime)];
            case 1:
                deps = _c.sent();
                _c.label = 2;
            case 2:
                _a = exports.parseUrlAssets(url), jsList = _a.jsList, cssList_1 = _a.cssList;
                moduleSandbox = createSandbox(sandbox, deps);
                return [4 /*yield*/, exports.moduleLoader.execModule({ name: name, url: jsList }, moduleSandbox, deps)];
            case 3:
                moduleInfo_1 = _c.sent();
                importModules[name] = {
                    moduleInfo: moduleInfo_1,
                    moduleSandbox: moduleSandbox,
                    moduleCSS: cssList_1,
                };
                _c.label = 4;
            case 4:
                _b = importModules[name], moduleInfo = _b.moduleInfo, moduleCSS = _b.moduleCSS;
                if (!moduleInfo) {
                    errMsg = 'load or exec module faild';
                    console.error(errMsg);
                    return [2 /*return*/, Promise.reject(new Error(errMsg))];
                }
                mount = targetModule.mount || (moduleInfo === null || moduleInfo === void 0 ? void 0 : moduleInfo.mount);
                unmount = targetModule.unmount || (moduleInfo === null || moduleInfo === void 0 ? void 0 : moduleInfo.unmount);
                component = moduleInfo.default || moduleInfo;
                if (!mount || !unmount) {
                    console.error('[icestark module] Please export mount/unmount function');
                }
                cssList = filterAppendCSS(moduleCSS);
                if (!cssList.length) return [3 /*break*/, 6];
                return [4 /*yield*/, Promise.all(cssList.map(function (css) { return appendCSS(name, css); }))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6:
                if (typeof moduleInfo.component !== 'undefined') {
                    console.warn('[icestark module] The export function name called component is conflict, please change it or it will be ignored.');
                }
                return [2 /*return*/, __assign(__assign({}, moduleInfo), { mount: mount,
                        unmount: unmount,
                        component: component })];
        }
    });
}); };
/**
 * mount module function
 */
exports.mountModule = function (targetModule, targetNode, props, sandbox) {
    if (props === void 0) { props = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, mount, component;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, exports.loadModule(targetModule, sandbox)];
                case 1:
                    _a = _b.sent(), mount = _a.mount, component = _a.component;
                    return [2 /*return*/, mount(component, targetNode, props)];
            }
        });
    });
};
/**
 * unmount module function
 */
exports.unmoutModule = function (targetModule, targetNode) {
    var _a, _b, _c;
    var name = targetModule.name;
    var moduleInfo = (_a = importModules[name]) === null || _a === void 0 ? void 0 : _a.moduleInfo;
    var moduleSandbox = (_b = importModules[name]) === null || _b === void 0 ? void 0 : _b.moduleSandbox;
    var unmount = targetModule.unmount || (moduleInfo === null || moduleInfo === void 0 ? void 0 : moduleInfo.unmount);
    var cssList = filterRemoveCSS((_c = importModules[name]) === null || _c === void 0 ? void 0 : _c.moduleCSS);
    removeCSS(name, document, cssList);
    if (moduleSandbox === null || moduleSandbox === void 0 ? void 0 : moduleSandbox.clear) {
        moduleSandbox.clear();
    }
    if (unmount && targetNode) {
        return unmount(targetNode);
    }
};
